import { Outlet } from 'react-router'
import Default from './assets/visual_signup.svg'
import extendLogo from '@/assets/logo_dark_extended.svg'
import { PostHogPageView } from '@/feature/posthog/page-view'

export const PublicLayout = () => (
  <>
    <div className='flex h-screen w-full items-center justify-center bg-[#F5F5F5]'>
      <section className='flex h-full max-h-[752px] w-full max-w-[1200px] justify-center gap-5'>
        <div className='h-full w-full max-w-[748px] overflow-y-scroll rounded-md'>
          <Outlet />
        </div>
        <div className='relative h-full w-full max-w-[452px] overflow-hidden rounded-md'>
          <img src={Default} alt='Curves and lines' className='h-full w-full object-cover' />
        </div>
      </section>
    </div>
    <title>Valueize - Login</title>
    <meta name='description' content='Login to Valueize' />
    <PostHogPageView />
  </>
)

export const LogoExtended = () => (
  <div className='flex w-full items-start justify-start'>
    <img src={extendLogo} width={61} height={16} alt='Logo' />
  </div>
)
